import { useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { signOut } from 'firebase/auth';
import { onSnapshot, collection, query } from "firebase/firestore"

import { AuthContext } from '../App'
import { auth, database } from '../services/firebase'

import avatar from '../assets/images/avatar.jpg'

import styles from '../styles/components/header.module.scss'
import { ToastContainer } from 'react-toastify'

export function Header() {
    const [mainMenu, setMainMenu] = useState(false)
    const [list, setList] = useState<any | null>([])

    const { user, userSettings } = useContext<any>(AuthContext)

    useEffect(() => {
        let isMounted = true

        const q = query(collection(database, "startups"))

        if (isMounted) {
            onSnapshot(q, (querySnapshot) => {
                const items: any = [];
                
                querySnapshot.forEach((doc) => {
                    items.push({ id: doc.id, ...doc.data() })
                })
    
                const filtered = (value: any) => {
                    if (value.owner.id === userSettings?.id)
                  
                    return value
                }
                
                const filteredItems = items.filter(filtered)
    
                setList(filteredItems)
            })
        }

        return () => {
            isMounted = false
        }
    }, [])

    function handleMainMenu() {
        let isMounted = true

        if (isMounted) {
            setMainMenu(!mainMenu)
        }

        return () => {
            isMounted = false;
        }
    }

    function handleSignOut() {
        signOut(auth)

        location.href = 'https://inovaparq.com.br/app'
    }

    return (
        <>
            <div className={styles.menuHeader}>
                <div className={`${ styles.header } ${ mainMenu ? styles.active : '' }`}>
                    <div className={styles.logo}>
                        <Link to="/">
                            <svg viewBox="0 0 209.76 44.31"><g id="a"/><g id="b"><g id="c"><rect className="d" x="0" y=".59" width="7.08" height="31.29"/><path className="d" d="M28.64,.85c-.26-.09-.53-.17-.82-.24l-.06-.02,.06,.02s-.04,0-.06-.01h0c-.54-.16-1.21-.28-1.96-.38-.82-.11-1.69-.17-2.63-.19-5.56-.19-12.9,.56-12.9,.56V31.89h7.08V5.35c.77-.31,1.51-.53,2.21-.67,.7-.14,1.59-.2,2.67-.2,2.05,0,3.5,.49,4.35,1.48,.85,.99,1.28,2.24,1.28,3.74V31.89h7.08V9.59c0-2.79-.99-5.08-2.96-6.88-.88-.8-2.01-1.41-3.36-1.86"/><path className="d" d="M50.25,.01c-4.26,0-7.49,1.49-9.69,4.47-2.21,2.98-3.31,6.91-3.31,11.79s1.12,8.7,3.37,11.7c2.24,3,5.46,4.5,9.64,4.5s7.49-1.49,9.7-4.47c2.21-2.98,3.31-6.89,3.31-11.73s-1.1-8.85-3.31-11.82C57.74,1.49,54.5,.01,50.25,.01m4.73,24.53c-.83,2.07-2.41,3.11-4.73,3.11s-3.8-1.05-4.67-3.14c-.87-2.09-1.31-4.86-1.31-8.3s.43-6.4,1.28-8.53c.85-2.13,2.42-3.19,4.7-3.19s3.95,1.04,4.76,3.13c.81,2.09,1.22,4.95,1.22,8.59s-.42,6.26-1.25,8.33"/><path className="d" d="M82.74,.59s-6.41,24.02-6.53,24.51c-.13-.5-6.27-24.5-6.27-24.5h-7.55l10.22,31.29h6.73L89.38,.59h-6.64Z"/><path className="d" d="M109.5,2.54C107.4,.86,104.59,.01,101.07,.01c-2.29,0-4.31,.23-6.08,.7-1.76,.46-3.32,1.03-4.68,1.68l1.63,4.06c1.24-.62,2.5-1.09,3.78-1.42,1.28-.33,2.64-.49,4.07-.49,2.02,0,3.56,.39,4.63,1.16,1.07,.78,1.6,2.11,1.6,4.01v1.68c-5.54,.54-9.83,1.65-12.89,3.34-3.06,1.68-4.59,4.42-4.59,8.22,0,3.06,1.07,5.41,3.22,7.05,2.15,1.65,5.33,2.47,9.55,2.47,2.36,0,4.52-.21,6.47-.64,1.95-.43,3.57-.97,4.85-1.63V10.81c0-3.83-1.05-6.59-3.14-8.27m-3.48,25.11c-1.17,.58-2.59,.87-4.26,.87-2.14,0-3.77-.47-4.9-1.42-1.13-.95-1.69-2.41-1.69-4.38,0-2.67,.88-4.55,2.63-5.63,1.75-1.08,4.49-1.86,8.23-2.32v12.89Z"/><path className="d" d="M126.01,.01c-2.44,0-4.52,.19-6.24,.58-1.72,.39-3.26,.95-4.62,1.68V44.31h7.03v-12.66c.5,.19,1.2,.35,2.09,.47,.89,.12,1.76,.17,2.61,.17,4.14,0,7.47-1.47,9.99-4.41,2.52-2.94,3.77-6.95,3.77-12.02s-1.3-8.88-3.89-11.67C134.16,1.41,130.58,.01,126.01,.01m5.49,24.94c-1.41,2.07-3.47,3.11-6.18,3.11-1.28,0-2.32-.17-3.14-.52V4.89c1.04-.43,2.26-.64,3.66-.64,2.82,0,4.83,.99,6.01,2.96,1.18,1.97,1.77,4.93,1.77,8.88s-.71,6.78-2.12,8.85"/><path className="d" d="M162.96,2.54C160.87,.86,158.06,.01,154.53,.01c-2.29,0-4.31,.23-6.08,.7-1.76,.46-3.32,1.03-4.68,1.68l1.63,4.06c1.24-.62,2.5-1.09,3.78-1.42,1.28-.33,2.64-.49,4.07-.49,2.02,0,3.56,.39,4.62,1.16,1.07,.78,1.6,2.11,1.6,4.01v1.68c-5.54,.54-9.83,1.65-12.89,3.34-3.06,1.68-4.59,4.42-4.59,8.22,0,3.06,1.07,5.41,3.22,7.05,2.15,1.65,5.33,2.47,9.55,2.47,2.36,0,4.52-.21,6.47-.64,1.95-.43,3.57-.97,4.85-1.63V10.81c0-3.83-1.05-6.59-3.14-8.27m-3.48,25.11c-1.17,.58-2.59,.87-4.26,.87-2.14,0-3.77-.47-4.9-1.42-1.13-.95-1.69-2.41-1.69-4.38,0-2.67,.88-4.55,2.63-5.63,1.75-1.08,4.49-1.86,8.23-2.32v12.89Z"/><path className="d" d="M199.42,.01c-5.11,0-8.91,1.55-11.41,4.64-2.5,3.1-3.74,7.22-3.74,12.37,0,4.68,1.15,8.41,3.45,11.18,2.3,2.77,5.31,4.15,9.03,4.15,1.28,0,2.4-.12,3.37-.35,.97-.23,1.84-.54,2.61-.93v13.24h7.02V2.28c-1.2-.7-2.64-1.25-4.33-1.65-1.68-.41-3.69-.61-6.01-.61m3.31,27.05c-1.12,.66-2.48,.99-4.06,.99-2.52,0-4.37-.99-5.57-2.96-1.2-1.97-1.8-4.82-1.8-8.53,0-3.95,.65-7,1.95-9.14,1.3-2.15,3.24-3.22,5.83-3.22,1.59,0,2.81,.21,3.66,.64V27.07Z"/><path className="d" d="M179.77,.01c-2.44,0-4.52,.19-6.24,.58-1.72,.39-3.26,.95-4.62,1.68V31.89h7.03V5.41c1.04-.43,2.26-.64,3.66-.64,1.94,0,3.48,.48,4.64,1.41l1.98-4.98c-1.87-.79-4.02-1.19-6.45-1.19"/></g></g></svg>
                        </Link>
                    </div>

                    <div className={styles.menu}>
                        <span>{ userSettings?.name }</span>

                        <div className={styles.menuPicture}>
                            <figure>
                                <img src={userSettings?.imageUrl ? userSettings.imageUrl : avatar } alt="" />
                            </figure>

                            { list.length > 0 ? (
                                <figure>
                                    <img src={list[0].imageUrl} alt="" />
                                </figure>
                            ) : ''}
                        </div>

                        {/* <div className={styles.menuSearch}>
                            <a href="#"> 
                                <svg viewBox="0 0 50 50" width="20px" height="20px">
                                    <g>
                                    <path d="M 21 3 C 11.601562 3 4 10.601562 4 20 C 4 29.398438 11.601562 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601562 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z M 21 7 "/>
                                    </g>
                                </svg>
                            </a>
                        </div> */}

                        <div onClick={handleMainMenu} className={styles.menuHamburguer}>
                            <svg fill="#fff" viewBox="0 0 24 24" width="25px" height="25px"><path d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"/></svg>
                        </div>
                    </div>
                </div>

                { mainMenu ? (
                    <div className={styles.mainMenu}>
                        <div onClick={handleMainMenu} className={styles.closeMainMenu}>
                            <svg width="15" height="15" viewBox="5 5 15 15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </div>

                        <Link className={styles.mainMenuButton} to="/user/startups">minha Startup</Link>
                        <Link className={styles.mainMenuButton} to={ `/user/perfil/${userSettings.id}` }>minha Conta</Link>
                        { userSettings.email == 'christian.abdou@hotmail.com' || userSettings.email == 'mfs.murillo@gmail.com' || userSettings.email == 'marcelo.leandro@univille.br' || userSettings.email == 'wagner.giovani@univille.br' || userSettings.email == 'liviameinert@gmail.com' ? 
                            (<Link className={styles.mainMenuButton} to="/admin">Admin</Link>) : ''
                        }
                        <div className={styles.mainMenuButton} style={{ background: '#ec4238', color: '#fff' }} onClick={handleSignOut}>Fazer logout</div>
                    </div>
                ) : ( null ) }

                { userSettings?.type === 'inover' ? (
                    <div className={styles.contagemInovers}>
                        <div className={styles.inoverHolder}>
                            <div className={styles.inoverIndice} style={{ width: Math.round( userSettings?.points / 60) }}><span>Seu índice inover: { (userSettings?.points / 60).toFixed(1) }h</span></div>
                            <div className={styles.inoverMedia}><span>Média dos inovers</span></div>
                        </div>
                    </div>
                ) : ( null ) }       

                { userSettings?.type === 'academico' ? (
                    <div className={styles.contagemHoras}>
                        <p>
                            <span>{ (userSettings?.points / 60).toFixed(1) }</span>
                            horas complementares
                        </p>

                        <p>
                            <span>{ userSettings?.certificates }</span>
                            certificados
                        </p>
                    </div>
                ) : ( null ) }     
            </div>

            <ToastContainer
                position="bottom-center"
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}